import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({
  bgImage,
  title = "",
  startDate,
  startHour,
  startMinute,
  startTimeType,
  endDate,
  endHour,
  endMinute,
  endTimeType,
  locationName = "",
  address,
  meetingLink = "",
  extraDetails = "",
  rsvpOption = "0",
}) => {
  const dateFormat = (date, hour, minute, timeType) => {
    if (hour && minute && timeType) {
      return `${new Date(
        `${date} ${hour}:${minute} ${timeType}`
      ).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      })}`
    } else {
      return `${new Date(date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}`
    }
  }

  const displayDate = () => {
    if (startDate && !endDate) {
      return (
        <p style={{ margin: "0px" }}>
          {dateFormat(startDate, startHour, startMinute, startTimeType)}
        </p>
      )
    } else if (startDate && endDate) {
      return (
        <>
          <p style={{ margin: "0px" }}>
            {dateFormat(startDate, startHour, startMinute, startTimeType)}
          </p>
          <p style={{ margin: "0px" }}>to</p>
          <p style={{ margin: "0px" }}>
            {dateFormat(endDate, endHour, endMinute, endTimeType)}
          </p>
        </>
      )
    } else if (!startDate && endDate) {
      return (
        <>
          <p style={{ margin: "0px" }}>Ends on:</p>
          <p style={{ margin: "0px" }}>
            {dateFormat(endDate, endHour, endMinute, endTimeType)}
          </p>
        </>
      )
    }
  }

  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div
          style={{
            fontSize: "20px",
            textAlign: "center",
            color: "white",
            paddingBlockStart: "2em",
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: "14px",
            textAlign: "center",
            color: "white",
            paddingBlockStart: "2em",
          }}
        >
          {displayDate()}
        </div>
        <p
          style={{
            fontSize: "14px",
            textAlign: "center",
            color: "white",
            paddingBlockStart: "1em",
          }}
        >
          {locationName}
        </p>
        {address && address?.address && (
          <p
            style={{
              fontSize: "14px",
              textAlign: "center",
              color: "white",
              textDecoration: "underline lightgreen",
            }}
          >
            {address?.address}
          </p>
        )}
        <p
          style={{
            fontSize: "10px",
            textAlign: "center",
            color: "white",
          }}
        >
          {meetingLink}
        </p>
        {extraDetails && (
          <div
            style={{
              fontSize: "14px",
              textAlign: "center",
              color: "white",
              paddingBlockStart: "2em",
              paddingBlockEnd: "2em",
              border: "1px solid white",
              marginRight: "6px",
            }}
            dangerouslySetInnerHTML={{ __html: extraDetails }}
          />
        )}
        {rsvpOption === "1" && (
          <div
            style={{
              backgroundImage: `url(https://admin.dev.markedprivate.com/app/images/preview/rsvp_options.png)`,
              width: "100%",
              height: "35%",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        )}
      </div>
    </PhoneArea>
  )
}

export default Preview
